import bylw from '../../assets/bylw.png';
import dbppt from '../../assets/dbppt.png';
import gsjx from '../../assets/gsjx.png';
import kclw from '../../assets/kclw.png';
import ktbg from '../../assets/ktbg.png';
import lwjc from '../../assets/lwjc2.png';
import qklw from '../../assets/qklw.png';
import wxzs from '../../assets/wxzs.png';

import iconCodeActiveUltra from '../../assets/icon-code-active-ultra.svg';
import iconCodeActive from '../../assets/icon-code-active.svg';
import iconCode from '../../assets/icon-code.svg';
import iconDiagramActiveUltra from '../../assets/icon-diagram-active-ultra.svg';
import iconDiagramActive from '../../assets/icon-diagram-active.svg';
import iconDiagram from '../../assets/icon-diagram.svg';
import iconFormulaActiveUltra from '../../assets/icon-formula-active-ultra.svg';
import iconFormulaActive from '../../assets/icon-formula-active.svg';
import iconFormula from '../../assets/icon-formula.svg';
import iconTableActiveUltra from '../../assets/icon-table-active-ultra.svg';
import iconTableActive from '../../assets/icon-table-active.svg';
import iconTable from '../../assets/icon-table.svg';
import iconDataActiveUltra from '../../assets/icon-data-active-ultra.svg';
import iconDataActive from '../../assets/icon-data-active.svg';
import iconData from '../../assets/icon-data.svg';

import bylwTitle from '../../assets/bylw-title.png';
import dbpptTitle from '../../assets/dbppt-title.png';
import gsjxTitle from '../../assets/gsjx-title.png';
import kclwTitle from '../../assets/kclw-title.png';
import ktbgTitle from '../../assets/ktbg-title.png';
import lwjcTitle from '../../assets/lwjc-title.png';
import qklwTitle from '../../assets/qklw-title.png';
import wxzsTitle from '../../assets/wxzs-title.png';

// 文档类型常量
export const DocType = {
    /** 毕业长文 */
    GRADUATION_THESIS: 'GRADUATION_THESIS',
    /** 期刊长文 */
    TERM_PAPER: 'TERM_PAPER',
    /** 开题报告 */
    PROPOSAL_REPORT: 'PROPOSAL_REPORT',
    /** 文献综述 */
    LITERATURE_REVIEW: 'LITERATURE_REVIEW',
    /** 答辩PPT */
    DEFENSE_PPT: 'DEFENSE_PPT',
    /** 课程长文 */
    COURSE_THESIS: 'COURSE_THESIS',
    /** 格式化 */
    FORMATTER: 'FORMATTER',
    /** 长文降重 */
    THESIS_MODIFICATION: 'THESIS_MODIFICATION',
};

// 新版写作流程（首页需求配置 → 参考资料 → 确认大纲 → 预览全文）接管的文档类型
export const NEW_WRITING_DOC_TYPES = [
    DocType.GRADUATION_THESIS,
    DocType.PROPOSAL_REPORT,
    DocType.LITERATURE_REVIEW,
    DocType.COURSE_THESIS,
];

// 手机首页只保留 毕业长文 / 开题报告 / 文献综述 三个分段页签：其余 Tab 在手机上隐藏（桌面不变）
export const MOBILE_HIDDEN_DOC_TYPES = [
    DocType.COURSE_THESIS,
    DocType.FORMATTER,
    DocType.DEFENSE_PPT,
    DocType.THESIS_MODIFICATION,
];

// 首页 Tab ↔ 新版写作 queryType
export const DOC_TYPE_TO_QUERY_TYPE = {
    [DocType.GRADUATION_THESIS]: 'PAPER',
    [DocType.PROPOSAL_REPORT]: 'OPENING_REPORT',
    [DocType.LITERATURE_REVIEW]: 'LITERATURE_REVIEW',
    [DocType.COURSE_THESIS]: 'COURSE_PAPER',
};

export const QUERY_TYPE_TO_DOC_TYPE = Object.fromEntries(
    Object.entries(DOC_TYPE_TO_QUERY_TYPE).map(([docType, queryType]) => [queryType, docType]),
);

// 文档类型分组
export const DocTypeGroups = {
    // 支持字数和模型选择的类型
    SUPPORT_WORD_COUNT_AND_MODEL: [
        DocType.GRADUATION_THESIS,
        DocType.TERM_PAPER,
        DocType.COURSE_THESIS,
    ],
    // 支持图表代码等选择的类型（非开题报告和文献综述）
    SUPPORT_EXTRA_CONTENT: [
        DocType.GRADUATION_THESIS,
        DocType.TERM_PAPER,
        DocType.COURSE_THESIS,
        DocType.DEFENSE_PPT,
        DocType.THESIS_MODIFICATION,
    ],
    // 支持三级大纲的类型
    SUPPORT_THREE_OUTLINE: [
        DocType.GRADUATION_THESIS,
        DocType.TERM_PAPER,
        DocType.COURSE_THESIS,
        DocType.THESIS_MODIFICATION,
    ],
    // 支持补充说明的类型(非降重的就行)
    SUPPORT_ADDITIONAL_INFORMATION: [
        DocType.GRADUATION_THESIS,
        DocType.TERM_PAPER,
        DocType.PROPOSAL_REPORT,
        DocType.LITERATURE_REVIEW,
        DocType.COURSE_THESIS,
    ],
};

// 工具函数：检查文档类型是否支持某个特性
export const isDocTypeSupport = {
    wordCountAndModel: (docType) => DocTypeGroups.SUPPORT_WORD_COUNT_AND_MODEL.includes(docType),
    extraContent: (docType) => DocTypeGroups.SUPPORT_EXTRA_CONTENT.includes(docType),
    threeOutline: (docType) => DocTypeGroups.SUPPORT_THREE_OUTLINE.includes(docType),
    additionalInformation: (docType) =>
        DocTypeGroups.SUPPORT_ADDITIONAL_INFORMATION.includes(docType),
};

export const DOC_TYPES = [
    {
        key: DocType.GRADUATION_THESIS,
        label: '毕业长文',
        icon: bylw,
        titleIcon: bylwTitle,
        subTitle: '撰写完整的学术长文，包括引言、文献综述、方法、结果、讨论和结论等',
    },
    // {
    //     key: DocType.TERM_PAPER,
    //     label: '期刊长文',
    //     icon: qklw,
    //     titleIcon: qklwTitle,
    //     subTitle: '帮助撰写符合期刊要求的高质量学术长文',
    // },
    {
        key: DocType.PROPOSAL_REPORT,
        label: '开题报告',
        icon: ktbg,
        titleIcon: ktbgTitle,
        subTitle: '提供研究背景、目标及方法的框架支持',
    },
    {
        key: DocType.LITERATURE_REVIEW,
        label: '文献综述',
        icon: wxzs,
        titleIcon: wxzsTitle,
        subTitle: '整理并分析相关研究，提炼核心观点',
    },
    {
        key: DocType.DEFENSE_PPT,
        label: '答辩PPT',
        icon: dbppt,
        titleIcon: dbpptTitle,
        subTitle: '制作逻辑清晰、内容精炼的答辩演示文稿',
    },
    {
        key: DocType.COURSE_THESIS,
        label: '课程长文',
        icon: kclw,
        titleIcon: kclwTitle,
        subTitle: '辅助完成课程相关的小长文或作业',
    },
    {
        key: DocType.FORMATTER,
        label: '格式精修',
        icon: gsjx,
        titleIcon: gsjxTitle,
        subTitle: '辅助完成课程相关的小论文或作业',
    },
    {
        key: DocType.THESIS_MODIFICATION,
        label: '降AIGC',
        icon: lwjc,
        titleIcon: lwjcTitle,
        subTitle: '改写文本，降低重复率，确保原创性 ',
    },
];

export const STEPS = [
    {
        title: '基本信息',
        key: 'basicInfo',
        step: 0,
    },
    {
        title: '生成大纲',
        key: 'outline',
        step: 1,
    },
    {
        title: '生成文章',
        key: 'content',
        step: 2,
    },
    {
        title: '全文导出',
        key: 'export',
        step: 3,
    },
];

// 毕业长文步骤
export const GRADUATION_THESIS_STEPS = [
    {
        title: '灵感',
        key: 'inspiration',
        step: 0,
    },
    {
        title: '标题',
        key: 'title',
        step: 1,
    },
    {
        title: '文献',
        key: 'literature',
        step: 2,
    },
    {
        title: '大纲',
        key: 'outline',
        step: 3,
    },
    {
        title: '摘要',
        key: 'abstract',
        step: 4,
    },
];
export const PPT_STEPS = [
    {
        title: '基本信息',
        key: 'basicInfo',
        step: 0,
    },
    {
        title: '生成大纲',
        key: 'outline',
        step: 1,
    },
    {
        title: '选择模板',
        key: 'template',
        step: 2,
    },
    {
        title: 'PPT导出',
        key: 'export',
        step: 3,
    },
];

export const REDUCE_STEPS = [
    {
        title: '上传全文',
        key: 'upload',
        step: 0,
    },
    {
        title: '选择段落',
        key: 'select',
        step: 1,
    },
    {
        title: '降重结果',
        key: 'result',
        step: 2,
    },
];

export const AUTO_LIGHT_TYPES = [
    {
        value: 'TABLE',
        label: '表',
        icon: iconTable,
        activeIcon: iconTableActive,
        activeUltraIcon: iconTableActiveUltra,
    },
    {
        value: 'DIAGRAM',
        label: '图',
        icon: iconDiagram,
        activeIcon: iconDiagramActive,
        activeUltraIcon: iconDiagramActiveUltra,
    },
    {
        value: 'DATA',
        label: '数据',
        icon: iconData,
        activeIcon: iconDataActive,
        activeUltraIcon: iconDataActiveUltra,
    },
    {
        value: 'FORMULA',
        label: '公式',
        icon: iconFormula,
        activeIcon: iconFormulaActive,
        activeUltraIcon: iconFormulaActiveUltra,
    },
    {
        value: 'CODE',
        label: '代码',
        icon: iconCode,
        activeIcon: iconCodeActive,
        activeUltraIcon: iconCodeActiveUltra,
    },
];

export const FEATURES = {
    left: [
        '灵感风暴快速生成全文',
        '灵感风暴提供真实参考文献',
        '灵感风暴提供文献综述、中英文摘要',
        // "灵感风暴提供5篇致谢模板",
    ],
    right: [
        '灵感风暴提供数据表、逻辑流程图、公式、相关代码片段等',
        '灵感风暴免费提供千字大纲，二级/三级任意切换',
        '灵感风暴提供开题报告、任务书、调查问卷、答辩汇报PPT等',
        '灵感风暴支持预览',
    ],
};

export const NOTICES = [
    '灵感风暴保护全文隐私安全，采用阿里云安全储存，加密传输，不泄漏任何全文信息。',
    '灵感风暴保留全文45天，生成60天后自动删除，请及时下载保存。',
    '灵感风暴所有生成的全文模板只可用作格式参考，不允许抄袭、代写、直接挪用等行为。',
];

// 文档类型枚举
export const DOCTYPEENUM = {
    /** 专业长文 */
    PAPER: 1,
    /** 文献综述 */
    WENXIAN_ZONGSHU: 2,
    /** 开题报告 */
    KAITI: 3,
    /** PPT */
    PPT: 4,
    /** 文献阅读 */
    WENXIAN_YUEDU: 5,
};

// 文档类型映射
export const DOCTYPEENUM_MAP = {
    [DOCTYPEENUM.PAPER]: '专业长文',
    [DOCTYPEENUM.WENXIAN_ZONGSHU]: '文献综述',
    [DOCTYPEENUM.KAITI]: '开题报告',
    [DOCTYPEENUM.PPT]: 'PPT',
    [DOCTYPEENUM.WENXIAN_YUEDU]: '文献阅读',
};

// 文档类型到UID类型的映射
export const DOCTYPE_UID_TYPE_MAP = {
    [DOCTYPEENUM.PAPER]: 1,
    [DOCTYPEENUM.WENXIAN_ZONGSHU]: 1,
    [DOCTYPEENUM.KAITI]: 1,
    [DOCTYPEENUM.PPT]: 2,
    [DOCTYPEENUM.WENXIAN_YUEDU]: 2,
};

// 文档类型到paperType的映射
export const DOCTYPE_PAPER_TYPE_MAP = new Map([
    [DocType.TERM_PAPER, 13],
    [DocType.COURSE_THESIS, 14],
]);
